import { FullProduct } from "ts/api/product";

export const getOrdersCount = (products: FullProduct[]) => {
  if (!products?.length) {
    return 0;
  }
  let count = 0;
  const hasNonReviewProduct = products.some((p) => !p.approval);
  if (hasNonReviewProduct) {
    count += 1;
  }
  const reviewRequiredProducts = products.reduce<string[]>((acc, curr) => {
    const { approval, owner } = curr;
    const shouldAdd = approval && !acc.includes(owner.id);
    if (shouldAdd) {
      acc.push(owner.id);
    }
    return acc;
  }, []);

  count += reviewRequiredProducts.length;
  return count;
};
